export { __ } from "@wordpress/i18n";

export function isEditing() {
  return window && window.wp && window.wp.editor;
}

// Image par défaut d'un smartProp à partir d'un fichier importé (png, svg).
// Le build génère la configuration PHP des blocs en exécutant block.js hors
// navigateur : l'import n'y est pas une URL, et `{ url }` y sortirait vide (`{}`).
// WordPress poserait alors ce `{}` au rendu à la place du défaut du moteur JS.
// Sans défaut côté PHP, c'est le moteur JS qui complète l'attribut, avec la vraie URL.
export function assetDefault(url) {
  return typeof url === "string" ? { url } : undefined;
}
